import { jsxs, jsx } from "react/jsx-runtime";
import { useSelected } from "slate-react";
const ScrollTargetRenderer = (props) => {
  const isSelected = useSelected();
  return /* @__PURE__ */ jsxs(
    "span",
    {
      ...props.attributes,
      title: props.element.identifier,
      style: {
        display: "inline-block",
        color: "#E0E0E0",
        boxShadow: isSelected ? "0 0 0 0.2em rgba(0, 148, 255, 0.3)" : "none",
        fontSize: ".8em",
        margin: "0 -.05em"
      },
      children: [
        /* @__PURE__ */ jsx("span", { contentEditable: false, children: "#" }),
        props.children
      ]
    }
  );
};
ScrollTargetRenderer.displayName = "ScrollTargetRenderer";
export {
  ScrollTargetRenderer
};
//# sourceMappingURL=ScrollTargetRenderer.js.map
